import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError(error.message);
      return;
    }

    if (!data.session) {
      setError("No session returned. Check email confirmation or auth settings.");
      return;
    }

    console.log("User logged in:", data.user);
    navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-white text-text-primary">
      <div className="flex flex-col md:flex-row w-full max-w-5xl rounded-2xl overflow-hidden shadow-2xl bg-bg-soft border border-border">

        {/* Left --- Login Form */}
        <div className="w-full md:w-1/2 p-10 md:p-12 bg-white">
          <h1 className="text-3xl font-extrabold mb-6 text-text-primary">Login Here!</h1>
          <p className="mb-10 text-text-secondary">
            Welcome back! Please sign in to your account.
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block mb-2 text-sm text-text-primary">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="name@email.com"
                className="w-full px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-accent bg-bg-soft border border-border text-text-primary placeholder:text-text-muted"
                required
              />
            </div>

            <div>
              <label className="block mb-2 text-sm text-text-primary">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-accent bg-bg-soft border border-border text-text-primary placeholder:text-text-muted"
                required
              />
            </div>

            {error && <p className="text-red-500 text-sm text-center">{error}</p>}

            <div className="flex items-center justify-between text-sm">
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                  className="form-checkbox focus:ring-0 accent-primary"
                />
                <span className="text-text-secondary">Remember me</span>
              </label>

              <Link
                to="/forgot-password"
                className="text-text-secondary hover:text-accent transition"
              >
                Forgot Password?
              </Link>
            </div>

            <button
              type="submit"
              className="w-full font-bold py-3 rounded-md transition bg-primary text-white hover:bg-primary-soft"
            >
              Login
            </button>
          </form>
        </div>

        {/* Right Section --- Design */}
        <div className="hidden md:flex w-1/2 relative items-center justify-center text-center p-10 bg-bg-soft">
          <div className="relative z-10 max-w-sm">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 rounded-full flex items-center justify-center bg-primary">
                <span className="text-2xl font-bold text-white">V</span>
              </div>
            </div>
            <h2 className="text-2xl font-bold mb-4 text-text-primary">Welcome to Vector Migration</h2>
            <p className="leading-relaxed text-text-secondary">
              Effortless vector database migration between <br /> Qdrant, Pinecone, and ChromaDB.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}